import { fieldError, type BuilderError } from '@customerio/dryad';

/**
 * The message for one input, behind the row's "touched" gate: a fresh row
 * holds back its validation errors until the input is visited, so it doesn't
 * open covered in red. A server error (`kind: 'external'`) is shown whether or
 * not the input was visited, because the server rejected a payload the user
 * already submitted and nothing else on the row would say why.
 */
export function gatedFieldError(errors: BuilderError[], field: string, isTouched: boolean): string | undefined {
  if (isTouched) {
    return fieldError(errors, field);
  }
  return fieldError(
    errors.filter((error) => error.kind === 'external'),
    field,
  );
}
